



















































































import Vue from 'vue';
import api from '@/shared/api';
import Select1 from '@/components/Select1.vue';
import { Incident } from '@/shared/api/types';

interface Props {
  canEdit: boolean;
}
type Option = {
  label: string;
  value: string | number;
};

interface Data {
  programOptions: Option[];
  seasonOptions: Option[];
  selectedProgram: string;
  selectedSeason: string;
  incidents: Incident[];
  incidentsCount: number;
  currentPage: number;
  pageSize: number;
  concernMap: {
    ChronicEpisode: 'Chronic Mental Health Episode';
    AcuteEpisode: 'Acute Mental Health Concern/Episode';
    SituationalCrisis: 'Situational Crisis';
    SocialIssue: 'Social Issue';
    Other: 'Other';
  };
  searchterm: string;
}

interface Methods {
  fetchData: () => Promise<void>;
  deleteIncident: (item: Incident) => void;
  handleCurrentChange: () => void;
  getConcernString: (concerns: Array<keyof Data['concernMap']>) => string;
}

export default Vue.extend<Data, Methods, {}, Props>({
  props: {
    canEdit: {}
  },
  data () {
    return {
      programOptions: [],
      seasonOptions: [{
        label: `${new Date().getFullYear()}`,
        value: `${new Date().getFullYear() - 1}-${new Date().getFullYear()}`
      }],
      selectedProgram: '',
      selectedSeason: `${new Date().getFullYear() - 1}-${new Date().getFullYear()}`,
      incidents: [],
      incidentsCount: 0,
      currentPage: 1,
      pageSize: 10,
      concernMap: {
        ChronicEpisode: 'Chronic Mental Health Episode',
        AcuteEpisode: 'Acute Mental Health Concern/Episode',
        SituationalCrisis: 'Situational Crisis',
        SocialIssue: 'Social Issue',
        Other: 'Other'
      },
      searchterm: ''
    };
  },
  async created () {
    const programsResponse = await api.getSummerPrograms();
    if (programsResponse && programsResponse.status === 200) {
      this.programOptions = programsResponse.data.map(item => {
        return { label: item.description, value: item.EventSubTypeID };
      });
      this.programOptions.unshift({ label: 'All Programs', value: '' });
    }

    const seasonsResponse = await api.getSeasons();
    if (seasonsResponse && seasonsResponse.status === 200) {
      this.seasonOptions = seasonsResponse.data.map(i => ({
        label: i.split('-')[1],
        value: i
      }));
      this.seasonOptions.unshift({ label: 'All Seasons', value: '' });
    }

    await this.fetchData();
  },
  watch: {
    $route: 'fetchData',
    searchterm: {
      async handler () {
        await this.fetchData();
      }
    },
    selectedProgram: async function () {
      await this.fetchData();
    },
    selectedSeason: async function () {
      await this.fetchData();
    }
  },
  components: { Select1 },
  methods: {
    fetchData: async function () {
      let where = this.selectedSeason ? `season="${this.selectedSeason}"` : '';
      where += where ? ' AND ' : '';
      where += this.selectedProgram
        ? 'EventSubTypeID=' + this.selectedProgram
        : '1=1';

      const response = await api.summerIncidentReportLookup(this.searchterm, this.currentPage, this.pageSize, where);
      if (response && response.status === 200) {
        this.incidents = response.data.Result;
        this.incidentsCount = response.data.TotalCount;
      }
    },
    deleteIncident: async function (item: Incident) {
      if (!item.SummerIncidentReportID) {
        return;
      }
      try {
        await this.$confirm('Are you sure you want to delete the entry?', 'Warning', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });
        const response = await api.deleteIncident(item.SummerIncidentReportID);
        if (response && response.status === 200) {
          this.incidents = this.incidents.filter(incident => {
            return (
              incident.SummerIncidentReportID !==
              item.SummerIncidentReportID
            );
          });

          this.$message({
            type: 'success',
            message: 'Delete completed'
          });
        }
      } catch (e) {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      }
    },
    handleCurrentChange: async function () {
      await this.fetchData();
    },
    getConcernString: function (concerns) {
      if (concerns) {
        return concerns.map(c => this.concernMap[c] || '').join(', ');
      }

      return '';
    }
  }
});
